import React from 'react'
import './why-choose-us.css'
import Common_title from '../../common-components/common-title/Common_title'

const Why_choose_us = () => {
    return (
        <>
            <section className='Why_choose_us_sec'>
                <div className='container-lg'>
                    <Common_title title="WHY CHOOSE US?" subtitle="Few reasons for people choosing" logo={process.env.PUBLIC_URL + '/assets/images/logo/bazar-wala2.png'} />

                    <div className='row mt-md-5 mt-3'>
                        <div className='col-xl-10 mx-auto'>
                            <div className='row'>
                                <div className='col-md-4 my-auto'>
                                    <div className='whychoosebox'>
                                        <div className='nodiv'>
                                            <p className='no'>1</p>
                                        </div>
                                        <div className='contdiv'>
                                            <h5 >A New Standard of Clean</h5>
                                            <p className='text'>Inspired by healthcare standards, our special process guarantees your food is exceptionally
                                                clean and safe. We obsess over hygiene so you don’t have to.</p>
                                        </div>
                                    </div>
                                    <div className='whychoosebox'>
                                        <div className='nodiv'>
                                            <p className='no'>2</p>
                                        </div>
                                        <div className='contdiv'>
                                            <h5 >Peak Freshness, Peak Energy</h5>
                                            <p className='text'>We deliver direct from the source, skipping long storage. This means your family gets food
                                                bursting with natural vitality, flavor, and energy.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-4 mb-md-0 mb-4'>
                                    <div className='img-div'>
                                        <img className='mobile-mockup' src={process.env.PUBLIC_URL + '/assets/images/home/download-app/mobile-2.png'} alt="mobile-mockup" />
                                    </div>
                                </div>
                                <div className='col-md-4 my-auto'>
                                    <div className='whychoosebox'>
                                        <div className='nodiv'>
                                            <p className='no'>3</p>
                                        </div>
                                        <div className='contdiv'>
                                            <h5 >Effortless Peace of Mind</h5>
                                            <p className='text'>No more worrying about where your food comes from. We do the hard work of ensuring
                                                quality, giving you back your time and complete peace of mind.</p>
                                        </div>
                                    </div>
                                    <div className='whychoosebox'>
                                        <div className='nodiv'>
                                            <p className='no'>4</p>
                                        </div>
                                        <div className='contdiv'>
                                            <h5 >A Founder's Personal Promise</h5>
                                            <p className='text'>We are not a faceless company. Our founder made a promise to care for every family as his
                                                own. Your well-being is our personal mission.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Why_choose_us